import { projectManagementApi } from '@/includes/projectManagementApi';

const pmPpcService = {
  async getProjectPpc(projectId, {
    weeks = 8,
    months = 4,
    scope = 'project',
    scopeId = null,
    period = 'week',
  } = {}) {
    const params = { weeks, months, scope, period };
    if (scopeId) {
      params.scopeId = scopeId;
    }
    const response = await projectManagementApi.get(`/projects/${projectId}/kpis/ppc`, {
      params,
    });
    return response.data;
  },

  async getPpcBreakdown(projectId) {
    const response = await projectManagementApi.get(
      `/projects/${projectId}/kpis/ppc/breakdown`,
    );
    return response.data;
  },
};

export default pmPpcService;
